
export default function UploadPGNForm() {
    return (<>Upload PGN Form Page</>);
}